export const PHONE_MASK = [
  '+',
  '1',
  ' ',
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const TAX_ID_MASK = [
  /[0-9]/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const SSN_MASK = [
  /[0-8]/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export const ZIP_MASK = [/\d/, /\d/, /\d/, /\d/, /\d/];

export const PASSPORT_MASK = [
  /[A-PR-WY]/,
  /[1-9]/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /[1-9]/,
];

export const DATE_MASK = [
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];


export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';

export const DATE_DAY_SMONTH_YEAR = 'MMM DD, YYYY';

export const DATE_MONTH_DAY_YEAR = 'MMMM DD, YYYY';

export const DATE_SMONTH_DAY_SYEAR = 'MM/DD/YY';

export const TIME_FORMAT = 'HH:mm';

export const TIME_HOUR_MINUTE_SECOND = 'HH:mm:ss';

export const FACEBOOK_BASE_URL = 'https://www.facebook.com/';

export const INSTAGRAM_BASE_URL = 'https://www.instagram.com/';

export const TWITTER_BASE_URL = 'https://twitter.com/';

export const LINKEDIN_BASE_URL = 'https://www.linkedin.com/company/';

export const PASSED_BACKGROUND_VALIDATION_STATUSES = ['Passed', 'Active'];

export const NEEDSREVIEW_BACKGROUND_VALIDATION_STATUSES = ['Needs Review'];

export const INITIAL_BACKGROUND_VALIDATION_STATUSES = ['Initial Request'];
